import React from 'react';
import PropTypes from 'prop-types';
import { INPUT_TYPE } from '../../helpers/formGroupVariants';
import CONTENT_STRINGS from '../../helpers/contentStrings';
import { Link } from 'arag-ui-lib';
import { TERTIARY, LEFT, OPPONENT_NAME_MN, } from "../../helpers/constants";
import { ANSWER_UPDATE_ACTION, DEFAULT_OPPONENT, } from '../../helpers/variables';
import OpponentQuestion from './opponentQuestion';
import CalendarInputType from './inputTypes/calendarInputType';
import TextInputType from './inputTypes/textInputType';
import AmountInputType from './inputTypes/amountInputType';
import TextAreaInputType from './inputTypes/textAreaInputType';
import UploadInputType from './inputTypes/uploadInputType';
import DropdownInputType from './inputTypes/dropdownInputType';
import TableInputType from './inputTypes/tableInputType';

const SharedApplicationFormQuestions = (props) => {
    const {
        question,
        formData,
        isPlain = false,
        value = '',
        application = {},
        questions = [],
        attachments = [],
        openDeleteAnswerModal = () => {},
        openEditQuestionAnswerModal = () => {},
        openHistoryModal = () => {},
        isAnswerEditModalOpen = false,
        isLabelClickable = false,
        hasInlineElements = false,
        dateHandler = () => {},
        textHandler = () => {},
        selectHandler = () => {},
        onDrop = () => {},
        handleBlur = () => {},
        medicalExpertFees = [],
        breachCausationCp = {},
        handleMedicalFeesTableRows = () => {},
        handleEditRowClick = () => {},
        medicalFeesTableHandler = () => {},
        downLoadFile = () => {},
        onAttachmentRequest = () => {},
        multipleFilesAllowed = false,
        fileDisabled = false,
        validateAmountTypeQuestion = () => {},
        questionValidation = {},
        workSourceOptions = [],
        textAreaRows = 3,
        mapEditingQuestionOrFieldToEditingSetting = () => {},
        approvalOptions = [],
        getApprovalSettings = () => {},
        checkIfPlainEditable = () => false,
        checkIfQuestionHasPendingChanges = () => false,
        checkIfQuestionsHasBeenModified = () => false,
        checkIfQuestionIsEditable = () => false,
        onClickActionLink = () => {},
        opponents = [],
        opponentHandler = () => {},
        onOpponentAdd = () => {},
        opponentQuestions = [],
        isApplicationTab,
    } = props;

    if (question.machineName === OPPONENT_NAME_MN) {
        return (
            <React.Fragment>
                {
                    opponents.map((opponent, index) => {
                        const opponentHasPendingChanges = checkIfQuestionHasPendingChanges( opponent.id, application, OPPONENT_NAME_MN )
                        return (
                            <OpponentQuestion
                                key={opponent.id}
                                opponent={opponent}
                                opponentQuestions={opponentQuestions}
                                openHistoryModal={openHistoryModal}
                                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                                isPlain={isPlain}
                                question={question}
                                checkIfPlainEditable={checkIfPlainEditable}
                                opponentHandler={opponentHandler}
                                opponentIndex={index}
                                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                                approvalOptions={approvalOptions}
                                displayRemoveButton={(index > 0)}
                                onClickActionLink={onClickActionLink}
                                application={application}
                                hasInlineElements={hasInlineElements}
                                opponentHasPendingChanges={opponentHasPendingChanges}
                                isApplicationTab={isApplicationTab}
                            />
                        )
                    })
                }
                {
                    !isAnswerEditModalOpen
                    ?
                        <Link
                            label={CONTENT_STRINGS.ADD_ANOTHER}
                            variant={TERTIARY}
                            arrowDirection={LEFT}
                            onClick={(
                                isPlain 
                                ?
                                    () => openEditQuestionAnswerModal({
                                        applicationUpdateAction: ANSWER_UPDATE_ACTION.ADD,
                                        questionAnswerForEdit: question,
                                        questionAnswerOpponent: DEFAULT_OPPONENT
                                    })
                                :
                                    onOpponentAdd
                            )}
                            linkTestId={'policy-application-OpponentAdd'}
                        /> 
                    : 
                        null
                }
            </React.Fragment>
        )
    }
    if (question.inputType === INPUT_TYPE.CALENDAR) {
        return (
            <CalendarInputType
                question={question}
                value={value}
                formData={formData}
                isPlain={isPlain}
                isAnswerEditModalOpen={isAnswerEditModalOpen}
                application={application}
                questions={questions}
                hasInlineElements={hasInlineElements}
                dateHandler={dateHandler}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
            />
        )
    }
    if(question.inputType === INPUT_TYPE.TEXT){
        return (
            <TextInputType
                question={question}
                value={value}
                formData={formData}
                isPlain={isPlain}
                application={application}
                hasInlineElements={hasInlineElements}
                textHandler={textHandler}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
            />
        )
    }
    if (question.inputType === INPUT_TYPE.TEXT_AREA) {
        return (
            <TextAreaInputType
                question={question}
                value={value}
                formData={formData}
                isPlain={isPlain}
                application={application}
                hasInlineElements={hasInlineElements}
                textHandler={textHandler}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
                textAreaRows={textAreaRows}
            />
        )
    }

    if (question.inputType === INPUT_TYPE.AMOUNT) {
        return (
            <AmountInputType
                question={question}
                value={value}
                formData={formData}
                isPlain={isPlain}
                application={application}
                hasInlineElements={hasInlineElements}
                textHandler={textHandler}
                handleBlur={handleBlur}
                validateAmountTypeQuestion={validateAmountTypeQuestion}
                questionValidation={questionValidation}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
            />
        )
    }

    if (question.inputType === INPUT_TYPE.UPLOAD) {
        return (
            <UploadInputType
                question={question}
                formData={formData}
                isPlain={isPlain}
                application={application}
                attachments={attachments}
                hasInlineElements={hasInlineElements}
                onDrop={onDrop}
                downLoadFile={downLoadFile}
                onAttachmentRequest={onAttachmentRequest}
                multipleFilesAllowed={multipleFilesAllowed}
                fileDisabled={fileDisabled}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
            />
        )
    }
    if (question.inputType === INPUT_TYPE.TABLE) {
        return (
            <TableInputType
                question={question}
                formData={formData}
                isPlain={isPlain}
                application={application}
                medicalExpertFees={medicalExpertFees}
                breachCausationCp={breachCausationCp}
                handleMedicalFeesTableRows={handleMedicalFeesTableRows}
                handleEditRowClick={handleEditRowClick}
                medicalFeesTableHandler={medicalFeesTableHandler}
                isAnswerEditModalOpen={isAnswerEditModalOpen}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                openDeleteAnswerModal={openDeleteAnswerModal}
                openHistoryModal={openHistoryModal}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                checkIfQuestionsHasBeenModified={checkIfQuestionsHasBeenModified}
                getApprovalSettings={getApprovalSettings}
                isLabelClickable={isLabelClickable}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                isApplicationTab={isApplicationTab}
            />
        )
    }

    if (question.inputType === INPUT_TYPE.DROP_DOWN) {
        return (
            <DropdownInputType
                question={question}
                value={value}
                formData={formData}
                isPlain={isPlain}
                application={application}
                questions={questions}
                attachments={attachments}
                mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
                approvalOptions={approvalOptions}
                openEditQuestionAnswerModal={openEditQuestionAnswerModal}
                openDeleteAnswerModal={openDeleteAnswerModal}
                openHistoryModal={openHistoryModal}
                isLabelClickable={isLabelClickable}
                hasInlineElements={hasInlineElements}
                checkIfPlainEditable={checkIfPlainEditable}
                checkIfQuestionsHasBeenModified={checkIfQuestionsHasBeenModified}
                checkIfQuestionIsEditable={checkIfQuestionIsEditable}
                getApprovalSettings={getApprovalSettings}
                isAnswerEditModalOpen={isAnswerEditModalOpen}
                selectHandler={selectHandler}
                checkIfQuestionHasPendingChanges={checkIfQuestionHasPendingChanges}
                workSourceOptions={workSourceOptions}
                // Additional props for child components
                dateHandler={dateHandler}
                textHandler={textHandler}
                onDrop={onDrop}
                handleBlur={handleBlur}
                medicalExpertFees={medicalExpertFees}
                breachCausationCp={breachCausationCp}
                handleMedicalFeesTableRows={handleMedicalFeesTableRows}
                handleEditRowClick={handleEditRowClick}
                medicalFeesTableHandler={medicalFeesTableHandler}
                downLoadFile={downLoadFile}
                onAttachmentRequest={onAttachmentRequest}
                multipleFilesAllowed={multipleFilesAllowed}
                fileDisabled={fileDisabled}
                validateAmountTypeQuestion={validateAmountTypeQuestion}
                questionValidation={questionValidation}
                textAreaRows={textAreaRows}
                onClickActionLink={onClickActionLink}
                opponents={opponents}
                opponentHandler={opponentHandler}
                onOpponentAdd={onOpponentAdd}
                opponentQuestions={opponentQuestions}
                isApplicationTab={isApplicationTab}
            />
        )
    }
    return null;
};

SharedApplicationFormQuestions.propTypes = {
    question: PropTypes.object.isRequired,
    formData: PropTypes.object.isRequired,
    isPlain: PropTypes.bool,
    value: PropTypes.any,
    application: PropTypes.object,
    questions: PropTypes.array,
    attachments: PropTypes.array,
    openDeleteAnswerModal: PropTypes.func,
    openEditQuestionAnswerModal: PropTypes.func,
    openHistoryModal: PropTypes.func,
    isAnswerEditModalOpen: PropTypes.bool,
    isMedExpertFeesTableEditable: PropTypes.bool,
    isLabelClickable: PropTypes.bool,
    hasInlineElements: PropTypes.bool,
    dateHandler: PropTypes.func,
    textHandler: PropTypes.func,
    selectHandler: PropTypes.func,
    onDrop: PropTypes.func,
    handleBlur: PropTypes.func,
    medicalExpertFees: PropTypes.array,
    breachCausationCp: PropTypes.object,
    handleMedicalFeesTableRows: PropTypes.func,
    handleEditRowClick: PropTypes.func,
    medicalFeesTableHandler: PropTypes.func,
    downLoadFile: PropTypes.func,
    onAttachmentRequest: PropTypes.func,
    multipleFilesAllowed: PropTypes.bool,
    fileDisabled: PropTypes.bool,
    validateAmountTypeQuestion: PropTypes.func,
    questionValidation: PropTypes.object,
    workSourceOptions: PropTypes.array,
    textAreaRows: PropTypes.number,
    mapEditingQuestionOrFieldToEditingSetting: PropTypes.func,
    approvalOptions: PropTypes.array,
    getApprovalSettings: PropTypes.func,
    checkIfPlainEditable: PropTypes.func,
    checkIfQuestionHasPendingChanges: PropTypes.func,
    checkIfQuestionsHasBeenModified: PropTypes.func,
    checkIfQuestionIsEditable: PropTypes.func,
    onOpponentAdd: PropTypes.func,
    opponents: PropTypes.array,
    opponentHandler: PropTypes.func,
    opponentQuestions: PropTypes.array,
};

export default SharedApplicationFormQuestions;